export default __webpack_public_path__ + "static/toby-310e9c9b3ec079b5f4c6745f46550b60.jpg";